import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { sendResponse } from "../../../api/api";

const TicketResponse = () => {
  const [response, setResponse] = useState("");
  const [statusMessage, setStatusMessage] = useState(null);
  const [statusType, setStatusType] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  const { ticket, customerEmail } =
    location.state || {};

  useEffect(() => {
    const token = localStorage.getItem("adminToken");

    if (!token) {
      navigate("/login", {
        state: { error: "Session expired. Please log in again." },
      });
      return;
    }

    if (!ticket) {
      navigate("/dashboard/booking-customer");
      return;
    }
  }, [navigate, ticket]);

  const handleSubmit = async () => {
    try {
      await sendResponse(ticket.ticket_id, customerEmail, response);
      setStatusMessage("Response Submitted and Email Sent Successfully");
      setStatusType("success");
      setResponse("");
    } catch (error) {
      console.error("Error submitting response:", error);
      setStatusMessage("Failed to submit response. Please try again.");
      setStatusType("error");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div style={{ margin: "50px" }}>
      <h2 style={{ fontWeight: "bold" }}>Customer Ticket Details</h2>

      {statusMessage && (
        <div
          style={{
            marginBottom: "20px",
            padding: "12px 20px",
            borderRadius: "6px",
            color: "var(--white-color)",
            backgroundColor:
              statusType === "success"
                ? "var(--success-color)"
                : "var(--danger-color)",
          }}
        >
          {statusMessage}
        </div>
      )}

      <div style={{ marginBottom: "20px" }}>
        <label
          htmlFor="response"
          style={{
            fontSize: "18px",
            display: "inline-block",
            marginBottom: "10px",
          }}
        >
          Response Description
        </label>
        <textarea
          id="response"
          value={response}
          onChange={(e) => setResponse(e.target.value)}
          style={{
            width: "100%",
            height: "150px",
            border: "1px solid var(--black-color)",
            borderRadius: "10px",
            padding: "10px",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>

      <div style={{ display: "flex", gap: "10px" }}>
        <button
          onClick={handleSubmit}
          style={{
            backgroundColor: "var(--primary-color)",
            color: "var(--black-color)",
            border: "none",
            borderRadius: "5px",
            padding: "10px 20px",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Submit Response
        </button>

        <button
          onClick={handleBack}
          style={{
            backgroundColor: "var(--secondary-color)",
            color: "var(--white-color)",
            border: "none",
            borderRadius: "5px",
            padding: "10px 20px",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default TicketResponse;
